import Vue from 'Vue';
import store from '@/store';
import _ from 'lodash';
import { BrandLimitService } from '@/services/rtps/brand-limit.service';

import {
    ERROR_HANDLE_ERROR,
    ERROR_CLEAR_ERROR
} from '../error/actions.type';

import {
    BRAND_LIMIT_CREATE,
    BRAND_LIMIT_SEARCH,
    BRAND_LIMIT_GET,
    BRAND_LIMIT_ADD,
    BRAND_LIMIT_ADD_OFFER,
    BRAND_LIMIT_REMOVE_OFFER,
    BRAND_LIMIT_REQUESTAPPROVAL,
    BRAND_LIMIT_APPROVE,
    BRAND_LIMIT_DENY,
    BRAND_LIMIT_PUBLISH,
    BRAND_LIMIT_CANCEL,
    BRAND_LIMIT_SAVE
} from './actions.type';

import {
    SET_BRAND_LIMIT_SEARCH,
    SET_BRAND_LIMIT_BUSY,
    SET_BRAND_LIMIT_GET,
    SET_BRAND_LIMIT_TEXT,
    SET_BRAND_LIMIT_UPPER_LIMIT,
    SET_BRAND_LIMIT_UNLIMITED_FLAG,
    SET_BRAND_LIMIT_ADD_OFFER,
    SET_BRAND_LIMIT_REMOVE_OFFER
} from './mutations.type';

const templateBrandLimit = {
    brand_limit_status_text: "new",
    record_type_name: "config",
    brand_limitation_text: "",
    brand_count_num: 0,
    upper_limit_num: 0,
    offer_unlimited_flag: false,
    copay_offers: []
};

const initialState = {
    searchCriteria: {},
    searchResults: { total: 0, records: [] },
    isSearchBusy: false,
    isBusy: false,
    currentBrandLimit: {}
};

export const state = Object.assign({}, initialState);

export const actions = {
    [BRAND_LIMIT_CREATE](context, params) {
        context.commit(SET_BRAND_LIMIT_GET, {
            brand_limit_status_text: "new",
            brand_limitation_text: "",
            record_type_name: "config",
            upper_limit_num: 0,
            brand_count_num: 0,
            offer_unlimited_flag: false,
            copay_offers: []
        });
    },
    [BRAND_LIMIT_SEARCH](context) {
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.query(store.getters.cognitoRoles)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_BRAND_LIMIT_SEARCH, data);
                }
                context.commit(SET_BRAND_LIMIT_BUSY, false);
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_GET](context, params) {
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.get(params.brand_limit_id, params.viewActive, store.getters.cognitoRoles)
            .then(({ data }) => {
                context.commit(SET_BRAND_LIMIT_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_BRAND_LIMIT_GET, data);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_ADD_OFFER](context, offer) {
        context.commit(SET_BRAND_LIMIT_ADD_OFFER, offer);
    },
    [BRAND_LIMIT_REMOVE_OFFER](context, offer) {
        context.commit(SET_BRAND_LIMIT_REMOVE_OFFER, offer);
    },
    [BRAND_LIMIT_ADD](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.add(brandLimit)
            .then(({ data }) => {
                context.commit(SET_BRAND_LIMIT_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_BRAND_LIMIT_GET, data);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_SAVE](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.save(brandLimit)
            .then(({ data }) => {
                context.commit(SET_BRAND_LIMIT_BUSY, false);
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                } else {
                    context.commit(SET_BRAND_LIMIT_GET, data);
                }
                return true;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                    return false;
                });
    },
    [BRAND_LIMIT_REQUESTAPPROVAL](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.requestApproval(brandLimit)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                } else {
                    context.dispatch(BRAND_LIMIT_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_APPROVE](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.approve(brandLimit)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                } else {
                    context.dispatch(BRAND_LIMIT_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_DENY](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.deny(brandLimit)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                } else {
                    context.dispatch(BRAND_LIMIT_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_PUBLISH](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.publish(brandLimit)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                } else {
                    context.dispatch(BRAND_LIMIT_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    },
    [BRAND_LIMIT_CANCEL](context, brandLimit) {
        context.dispatch(ERROR_CLEAR_ERROR);
        context.commit(SET_BRAND_LIMIT_BUSY, true);
        return BrandLimitService.cancelUpdate(brandLimit)
            .then(({ data }) => {
                if (data.errorMessage) {
                    context.dispatch(ERROR_HANDLE_ERROR, { message: data.errorMessage });
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                } else {
                    context.dispatch(BRAND_LIMIT_SEARCH);
                }
                return data;
            },
                (err) => {
                    context.commit(SET_BRAND_LIMIT_BUSY, false);
                    context.dispatch(ERROR_HANDLE_ERROR, err);
                });
    }
};

export const mutations = {
    [SET_BRAND_LIMIT_SEARCH](state, results) {
        state.searchResults = results;
    },
    [SET_BRAND_LIMIT_BUSY](state, isBusy) {
        state.isBusy = isBusy;
    },
    [SET_BRAND_LIMIT_GET](state, brandLimit) {
        const templateBrandLimitClone = JSON.parse(JSON.stringify(templateBrandLimit));
        state.currentBrandLimit = { ...templateBrandLimitClone, ...brandLimit };
    },
    [SET_BRAND_LIMIT_TEXT](state, value) {
        Vue.set(state.currentBrandLimit, "brand_limitation_text", value);
    },
    [SET_BRAND_LIMIT_UPPER_LIMIT](state, value) {
        Vue.set(state.currentBrandLimit, "upper_limit_num", value);
    },
    [SET_BRAND_LIMIT_UNLIMITED_FLAG](state, value) {
        Vue.set(state.currentBrandLimit, "offer_unlimited_flag", value);
    },
    [SET_BRAND_LIMIT_ADD_OFFER](state, offer) {
        if (!state.currentBrandLimit.copay_offers) {
            Vue.set(state.currentBrandLimit, "copay_offers", []);
        }
        state.currentBrandLimit.copay_offers.push(offer);
    },
    [SET_BRAND_LIMIT_REMOVE_OFFER](state, offer) {
        var foundOffer = _.find(state.currentBrandLimit.copay_offers, { copay_offer_id: offer.copay_offer_id });
        const index = state.currentBrandLimit.copay_offers.indexOf(foundOffer);
        if (index !== -1) {
            state.currentBrandLimit.copay_offers.splice(index, 1);
        }
    }
};

const getters = {
    brandLimitSearchResults: state => state.searchResults,
    currentBrandLimit: state => {
        return state.currentBrandLimit;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/brand-limit/brand-limit.module.js